var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inputNumber" }, [
    _c("span", {
      staticClass: "iconfont icon-jian",
      on: { click: _vm.numberMinus }
    }),
    _vm._v(" "),
    _c("span", [
      _c("input", {
        attrs: { type: "number", onfocus: "this.select()" },
        domProps: { value: _vm.numberOfSubCards },
        on: { keyup: _vm.update, blur: _vm.loseFocus }
      })
    ]),
    _vm._v(" "),
    _c("span", {
      staticClass: "iconfont icon-jia",
      on: { click: _vm.numberOfAdditions }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-889a0dce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-889a0dce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/paperless/components/quantityInputModule/index.vue
// module id = null
// module chunks = 